module.exports = __webpack_public_path__ + "04_long_brown.cd15bb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_long_brown.png
// module id = Up7z
// module chunks = 0